<template>
  <div>
    <My-new-nav ref="header" menuTheme="white"></My-new-nav>
    <div class="recruit">
      <img src="../../../assets/image/recruit_banner.png" alt="" />
      <div class="list">
        <div class="total">共{{ totalNumber }}个职位</div>
        <div
          class="item"
          v-for="(item, index) in positionList"
          :key="index"
          @click="onItemClick(item.id)"
        >
          <div class="jobName">{{ item.jobName }}</div>
          <div class="jobAddress">
            <span>{{ item.address ? item.address : "地点不限" }}</span>
            <span class="space">|</span>
            <span>{{
              item.recruitNumber ? item.recruitNumber : "人数不限"
            }}</span>
            <span class="space">|</span>
            <span>{{ item.degree ? item.degree : "学历不限" }}</span>
          </div>
          <div class="divide"></div>
        </div>
      </div>
      <div class="btn">
        <LoadMoreButton v-if="hasMore" @loadMore="loadMore" />
      </div>
    </div>
  </div>
</template>

<script>
import { selectAllPosition } from "../../../../common/api";
import {
  hiddenLoading,
  showLoading,
  showToast,
} from "../../../../common/toast";
import LoadMoreButton from "@/components/mobileMoreButton/index.vue";

export default {
  components: { LoadMoreButton },
  data() {
    return {
      positionList: [],
      totalNumber: 0,
      currentPage: 1,
      pageSize: 20,
      hasMore: false,
    };
  },
  activated() {
    this.getPositionList();
  },
  methods: {
    getPositionList() {
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        isOfficial: 1,
      };
      showLoading();
      selectAllPosition(params)
        .then((res) => {
          hiddenLoading();
          if (res.responseCode === 0) {
            this.positionList = this.positionList.concat(res.responseBody);
            this.totalNumber = res.count;
            this.hasMore = this.positionList.length < this.totalNumber;
          } else {
            showToast(res.responseMsg);
          }
        })
        .catch((e) => {
          console.log(e);
          showToast(e);
        })
    },
    loadMore() {
      this.currentPage = ++this.currentPage;
      this.getPositionList();
    },
    onItemClick(id) {
      this.routerJump("/recruitDetail_mobile", id);
    },
    routerJump(m, id) {
      let header = document.getElementById("app");
      header.scrollTop = 0;
      this.$store.commit("changeActiveMenu", m);
      window.scrollTo(0, 0);
      this.$router.push({ path: m + "/" + id });
    },
  },
};
</script>

<style lang="scss" scoped>
.recruit {
  background-color: #f5f6fa;
}

.recruit img {
  width: 100%;
  height: 520px;
}

.list {
  background: #ffffff;
}

.total {
  padding: 40px 36px 0 36px;
  color: #212121;
  font-size: 36px;
  font-weight: 600;
}

.item {
  position: relative;

  .jobName {
    font-weight: 600;
    color: #212121;
    font-size: 45px;
    margin: 21px 36px;
  }

  .jobAddress {
    margin: 20px 36px;
    font-weight: 500;
    color: #52647c;
    font-size: 36px;
  }

  .space {
    margin: 0 15px;
  }

  .divide {
    height: 1px;
    width: 100%;
    background: #e7e7e7;
  }
}

.btn {
  margin: 120px 36px 80px 36px;
}
</style>
